import React from 'react';
import SignupForm from '../components/signup/SignupForm';
import { motion } from 'framer-motion';
import Logo from '../components/shared/Logo';

const SignupPage: React.FC = () => {
  return (
    <div className="min-h-dvh bg-surface flex flex-col lg:flex-row font-sans">
      {/* Brand Section */}
      <div className="hidden lg:flex lg:w-2/5 bg-surface-container-lowest relative overflow-hidden items-center justify-center border-r border-outline-variant">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          className="relative z-20 text-left px-16"
        >
          <div
            className="inline-flex items-center gap-2 px-4 py-2 mb-8"
            style={{
              background: 'rgba(217, 86, 0, 0.08)',
              border: '1px solid rgba(217, 86, 0, 0.2)'
            }}
          >
            <svg
              className="w-4 h-4 text-tertiary"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M12 2L2 7l10 5 10-5-10-5z" />
              <path d="M2 17l10 5 10-5" />
            </svg>
            <span className="text-xs font-bold uppercase tracking-widest text-tertiary">
              Join our community
            </span>
          </div>

          <h1 className="text-7xl font-black text-on-surface mb-8 leading-[1.1] tracking-tight">
            Start your <br />
            <span className="text-tertiary">creative</span> <br />
            journey <span className="text-on-surface-variant/30">today</span>
          </h1>

          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-surface-container-high flex items-center justify-center border border-outline-variant shrink-0">
                <span className="material-icons text-tertiary">
                  check_circle
                </span>
              </div>
              <div>
                <h4 className="text-on-surface font-bold">
                  Unlimited Projects
                </h4>
                <p className="text-on-surface-variant text-sm">
                  Organize all your stories in one place.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-surface-container-high flex items-center justify-center border border-outline-variant shrink-0">
                <span className="material-icons text-tertiary">
                  verified_user
                </span>
              </div>
              <div>
                <h4 className="text-on-surface font-bold">Secure Backups</h4>
                <p className="text-on-surface-variant text-sm">
                  Your creative assets are always safe with us.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Form Section */}
      <div className="flex-1 flex flex-col justify-center items-center p-8 lg:p-24 bg-surface">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="w-full max-w-lg"
        >
          <div className="mb-12 text-center lg:text-left">
            <div className="w-16 h-16 bg-tertiary flex items-center justify-center mb-6 mx-auto lg:mx-0">
              <span className="material-icons text-white text-3xl">
                Auto_awesome_motion
              </span>
            </div>
            <h2 className="text-4xl font-bold text-on-surface mb-3 tracking-tight">
              Create Account
            </h2>
            <p className="text-on-surface-variant">
              Get started with your free trial.
            </p>
          </div>

          <SignupForm />

          <div className="mt-10 text-center">
            <p className="text-on-surface-variant text-sm">
              Already have an account?{' '}
              <a
                href="/login"
                className="text-tertiary font-semibold hover:underline decoration-2 underline-offset-4"
              >
                Log in instead
              </a>
            </p>
          </div>
        </motion.div>
      </div>

      {/* Footer Branding for Mobile */}
      <div className="lg:hidden p-8 border-t border-outline-variant text-center w-full">
        <Logo className="h-8 mx-auto" variant="invert" />
      </div>
    </div>
  );
};

export default SignupPage;
